const CNPJ_ACCESS = '21415772000164';

function idComparavel(valor) {
    return valor === undefined || valor === null || valor === '' ? null : String(valor);
}

function documentoNormalizado(valor) {
    return String(valor || '').replace(/\D/g, '');
}

function fornecedorEhAccess(subitem = {}, fornecedorAccessInterno = null) {
    const fornecedor = subitem.fornecedor || {};
    const fornecedorId = idComparavel(fornecedor.id);
    const accessId = idComparavel(fornecedorAccessInterno && fornecedorAccessInterno.id);

    return (Boolean(fornecedorId && accessId) && fornecedorId === accessId)
        || documentoNormalizado(fornecedor.cnpj) === CNPJ_ACCESS;
}

function normalizarSubitem(subitem = {}, fornecedorAccessInterno = null) {
    if (!fornecedorEhAccess(subitem, fornecedorAccessInterno)) {
        subitem.imposto = '0';
    }

    return subitem;
}

// A linha já cobra o % Imposto NF dela (gross-up no próprio total)? Então ela NÃO volta para a
// base do Imposto NF Access do grupo — senão a NF incide duas vezes. Mesma regra da API
// (OrcamentoImpostoNfAccess::calcularBasesGrupo / linhaComImpostoNfProprio): só fornecedor Access.
function temImpostoNfProprio(subitem = {}, fornecedorAccessInterno = null) {
    const percentual = Number(String(subitem.imposto ?? '').replace(',', '.')) || 0;
    return percentual > 0 && percentual < 100 && fornecedorEhAccess(subitem, fornecedorAccessInterno);
}

export const ImpostoNfAccessPorFornecedorPolicy = {
    fornecedorEhAccess,
    normalizarSubitem,
    temImpostoNfProprio,
};
